import React, { useRef } from "react";
import { showToast } from "../../utils/hot-toast";
import {
    PRESALE_UPCOMING,
    PRESALE_FILLED,
    PRESALE_CANCELED,
    PRESALE_ENDED,
    PRESALE_ENDED_NOT_MET_SOFTCAP,
    MAX_UINT256,
    PRESALE_FINALISED,
} from "../../utils/constants";

import { numberConverter } from "../../utils/utils";

import ERC20Abi from "../../abis/ERC20.json";
import TokenTimer from "../UI/TokenTimer";
import { usePCSRouterV2 } from "../../hooks";

import { ReactComponent as BinanceCoin } from "../../assets/images/launchpad/binance-coin.svg";

const ContributeAndClaim = ({
    coinPrice,
    presaleData,
    preSaleAddress,
    account,
    presaleContract,
    presaleStatus,
    tokenAddress,
    forceUpdate,
}) => {
    const valueConRef = useRef(null);
    const PCS_ROUTER_V2 = usePCSRouterV2();

    const contribute = async () => {
        if (valueConRef.current.value > 0 && presaleContract !== null) {
            try {
                await window.web3.eth.sendTransaction({
                    to: preSaleAddress,
                    from: account,
                    value: window.web3.utils.toWei(
                        valueConRef.current.value.toString(),
                        "ether"
                    ),
                });
                forceUpdate();
                showToast("SUCCESS", "Contributed Successfully!");
            } catch (error) {
                showToast("ERROR", "Something went wrong!");
                console.log(error.message);
            }
        }
    };
    const claimTokens = async () => {
        try {
            await presaleContract.methods
                .claimTokensForContribution()
                .send({ from: account });
            forceUpdate();
        } catch (error) {
            console.log(error.message);
        }
    };
    const claim = async () => {
        console.log(account);
        try {
            console.log(presaleContract.methods);
            await presaleContract.methods
                .claimBackContributionFree()
                .send({ from: account });
            forceUpdate();
        } catch (error) {
            console.log(error.message);
        }
    };

    const approvePCSV2 = async () => {
        try {
            const web3 = window.web3;
            const tokenContract = new web3.eth.Contract(
                ERC20Abi.abi,
                tokenAddress
            );

            await tokenContract.methods
                .approve(PCS_ROUTER_V2, MAX_UINT256)
                .send({ from: account });
        } catch (error) {
            console.log(error);
        }
    };

    const boxActionUIs = () => {
        switch (presaleStatus) {
            case PRESALE_UPCOMING:
                return (
                    <div className="text-kadGrSt size-1 mx-auto my-4">
                        Not Started Yet!
                    </div>
                );
            case PRESALE_FILLED:
                return (
                    <>
                        <span className="size-2 w-3/4 mx-auto my-3">
                            Presale reached cap, Waiting on developer to
                            finalise.
                        </span>
                        <button
                            className="bg-[#1fc7d4] text-white w-3/4 mx-auto mb-5 flex items-center justify-center gap-2"
                            onClick={approvePCSV2}
                        >
                            <img src="/images/Pancakeswap.svg" alt="PCS V2" />
                            Approve PCS
                        </button>
                    </>
                );

            case PRESALE_ENDED:
            case PRESALE_FINALISED:
                return (
                    <>
                        <button
                            className="blueGradient-button w-3/4 mx-auto mb-5 flex items-center gap-2"
                            onClick={approvePCSV2}
                        >
                            <img src="/images/Pancakeswap.svg" alt="PCS V2" />
                            Approve PCS
                        </button>
                        <button
                            className="secGr-button w-3/4 mx-auto mb-5"
                            onClick={claimTokens}
                        >
                            Claim Your Tokens
                        </button>
                    </>
                );
            case PRESALE_CANCELED:
            case PRESALE_ENDED_NOT_MET_SOFTCAP:
                return (
                    <button
                        className="blueGradient-button mx-auto mb-5"
                        onClick={claim}
                    >
                        Claim Contribution
                    </button>
                );
            default:
                // CASE TOKEN_PRESALE_DURING
                return (
                    <div className="flex flex-col items-center py-3">
                        {inputUI()}
                    </div>
                );
        }
    };

    const inputUI = () => {
        // if (presaleStatus == PRESALE_INPROGRESS)
        return (
            <div className="w-full flex relative">
                <input
                    ref={valueConRef}
                    type="text"
                    className="rounded-full w-full pl-6"
                    placeholder={`1 BNB = ${presaleData.presaleRate} ${presaleData.tokenSymbol}`}
                />

                <button
                    className="blueGradient-button text-[14px] absolute top-[4px] right-1 p-2 rounded-rull size-base font-semibold"
                    onClick={contribute}
                >
                    Contribute
                </button>
            </div>
        );
    };

    return (
        <div className="flex flex-col px-4 justify-center text-center">
            {boxActionUIs()}
            <div className="flex">
                <div className="flex flex-col items-start">
                    <span className="opacity-70">Amount Raised</span>
                    <div className="flex items-end">
                        <BinanceCoin className="border-2 border-[#0057FF33] rounded-full p-1 w-8 h-8" />
                        <span className="size-2 leading-7 mx-1">
                            {presaleData.progress}
                        </span>
                        <span className="opacity-70">
                            {" "}
                            / ${parseInt(coinPrice * presaleData.progress)}
                        </span>
                    </div>
                </div>
                <TokenTimer
                    icon={false}
                    className="flex flex-col items-end ml-auto"
                    status={presaleStatus}
                    currentTime={new Date().getTime() / 1000}
                    presaleStartTime={presaleData.presaleStartTime}
                    presaleEndTime={presaleData.presaleEndTime}
                    lockupTime={presaleData.lockupTime}
                />
            </div>
            <div className="flex justify-center size-sm pt-6">
                <div className="flex flex-col items-center gap-2">
                    <span>Amount of purchased tokens</span>
                    <span className="flex items-center gap-2 rounded-full text-kad-gradient size-1">
                        {numberConverter(
                            presaleData.presaleRate * presaleData.contribution
                        )}{" "}
                        {presaleData.tokenSymbol}
                    </span>
                </div>
                <div className="hidden md:block ml-auto w-[2px] h-full bg-kadComponentBorder" />
                <div className="ml-auto flex flex-col items-center gap-2">
                    <span>Your contributed amount</span>
                    <span className="flex items-center gap-2 rounded-full text-kad-gradient size-1">
                        <BinanceCoin />
                        {presaleData.contribution} BNB
                    </span>
                </div>
            </div>
        </div>
    );
};
export default ContributeAndClaim;
